import React, { useCallback } from "react";
import { numberFormat } from "helper";
import ReportingService from "Lib/API/reporting";
import useWidgetData from "./useWidgetData";
import WidgetWrapper from "./WidgetWrapper";
import "./widgets.scss";

const fmt = (n) => numberFormat({ number: n ?? 0, decimal: 0, style: "currency" });

const FuturePaymentsWidget = ({ customizeMode, onRemove }) => {
  const fetcher = useCallback((token) => ReportingService.getWidgetFuturePayments(token), []);
  const { data, loading, error, retry } = useWidgetData(fetcher);

  const months = data?.months || [];
  const maxTotal = Math.max(...months.map((m) => m.total), 1);
  const grandTotal = months.reduce((sum, m) => sum + m.total, 0);
  const grandCount = months.reduce((sum, m) => sum + m.count, 0);

  return (
    <WidgetWrapper
      title="Future Payments"
      loading={loading}
      error={error}
      onRetry={retry}
      customizeMode={customizeMode}
      onRemove={onRemove}
    >
      <div className="stat-widget">
        <div className="stat-widget__value">{fmt(grandTotal)}</div>
        <div className="stat-widget__sub">{grandCount} projected charge{grandCount !== 1 ? "s" : ""} over 6 months</div>
        <div className="bar-chart">
          {months.map((m, i) => {
            const barH = Math.max(Math.round((m.total / maxTotal) * 36), m.total > 0 ? 4 : 0);
            return (
              <div key={i} className="bar-chart__col">
                <div
                  className="bar-chart__bar"
                  style={{ height: barH }}
                  title={`${m.label}: ${fmt(m.total)} (${m.count} charge${m.count !== 1 ? "s" : ""})`}
                />
                <div className="bar-chart__lbl">{m.label.split(" ")[0]}</div>
                <div className="bar-chart__lbl" style={{ fontSize: 8 }}>{fmt(m.total)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </WidgetWrapper>
  );
};

export default FuturePaymentsWidget;
